import React, {Component} from "react";
import SubscriptionService from "../../service/SubscriptionService";

class SubscriptionProvider extends Component {
    componentDidMount() {
        this.refreshStatus();
    }

    /**
     * Fetch and display status
     */
    refreshStatus = () => {
        SubscriptionService.fetchSubscriptionStatus(true, (subscription) => {
            if (subscription) {
                this.showSubscription(subscription);
            }
        });
    };

    /**
     * Display subscription details.
     *
     * @param subscription
     */
    showSubscription = (subscription) => {
        let subscriptionState = {
            raw: subscription,
        };

        switch (subscription.status) {
            case 'active':
                subscriptionState.status = {
                    text: 'Active',
                    className: 'label-success'
                };
                subscriptionState.currentPlan = {
                    active: true,
                    name: subscription.planName,
                    description: subscription.planDescription,
                    priceAmount: subscription.priceAmount,
                    deploymentLimit: subscription.deploymentLimit,
                    cancellable: true
                };
                subscriptionState.subscribe = {
                    productVisible: false
                };
                break;

            case 'inactive':
                subscriptionState.status = {
                    text: 'Inactive',
                    className: 'label-warning'
                };
                subscriptionState.currentPlan = {
                    active: true,
                    name: subscription.planName,
                    description: subscription.planDescription,
                    priceAmount: subscription.priceAmount,
                    deploymentLimit: subscription.deploymentLimit,
                    cancellable: false
                };
                subscriptionState.subscribe = {
                    productVisible: true
                };
                break;

            default:
                subscriptionState.status = {
                    text: subscription.status,
                    className: 'label-danger'
                };
                subscriptionState.currentPlan = {
                    active: false
                };
                subscriptionState.subscribe = {
                    productVisible: false
                };
                break;
        }

        const planFeatures = [];

        if (subscriptionState.currentPlan.active) {
            planFeatures.push(
                <span><strong>{subscriptionState.currentPlan.deploymentLimit}</strong> monthly deployments</span>
            );

            if (subscriptionState.currentPlan.priceAmount === 0) {
                planFeatures.push(
                    <span className="text-muted">no build history</span>,
                    <span className="text-muted">no logs</span>
                )
            } else {
                planFeatures.push(
                    <span><strong>history</strong> of your builds</span>,
                    <span><strong>logs</strong> in real-time</span>
                )
            }
        }

        subscriptionState.planFeatures = planFeatures;

        this.props.callback(subscriptionState);
    }

    render() {
        return null;
    }
}

SubscriptionProvider.propTypes = {
    callback: React.PropTypes.func.isRequired,
};

export default SubscriptionProvider;



// WEBPACK FOOTER //
// ./src/modules/views/product/SubscriptionProvider.js